// Matches go-playground/validator's hostname_rfc1123 regex:
// ^([a-zA-Z0-9]{1}[a-zA-Z0-9-]{0,62}){1}(\.[a-zA-Z0-9]{1}[a-zA-Z0-9-]{0,62})*?$
const HOSTNAME_RFC1123_PATTERN =
  /^([a-zA-Z0-9][a-zA-Z0-9-]{0,62})(\.[a-zA-Z0-9][a-zA-Z0-9-]{0,62})*$/;

/**
 * Validates that a value is a valid RFC 1123 hostname (e.g. "example.com").
 * Returns an error message string if invalid, or `true` if valid.
 * Empty/blank values are considered valid (use `required` for that check).
 *
 * Compatible with react-hook-form's `validate` function signature.
 */
export function validateDomainName(value: unknown): string | true {
  if (typeof value !== 'string' || !value.trim()) {
    return true;
  }

  return (
    HOSTNAME_RFC1123_PATTERN.test(value.trim()) ||
    'Enter a valid domain (e.g. example.com)'
  );
}
